import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path d="M10.5 18.5c-.4 0-.8-.2-1.1-.5l-5-5.5c-.6-.6-.5-1.6.1-2.1.6-.6 1.6-.5 2.1.1l3.8 4.2 6.9-9.1c.5-.7 1.4-.8 2.1-.3.7.5.8 1.4.3 2.1l-8 10.5c-.3.4-.7.6-1.2.6z" />,
  'Checkmark'
)
